// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"90933614","252":"bcc97f4a","354":"abc7a137","450":"97b3934f","453":"b884f55c","789":"21a8b8f9","885":"36b60696"}[chunkId] + ".chunk.js";
};